import Modal from "../../components/Modal/Modal";
import React from "react";
import { useApp } from "../../contexts";
import styled from "styled-components";

const ContentWaper = styled.div`
  max-height: 80vh;
`;
export const ModalPolicy = ({ value, ...props }) => {
  const { T, language } = useApp();

  const onClose = () => {
    props.onClose();
  };
  const { handleSubmit } = { value, ...props };

  return (
    <Modal onClose={onClose}>
      <Modal.ModalBg2 onClose={onClose} />
      <Modal.Container2
        width="850px"
        onClose={onClose}
        className={
          "!py-[30px] !pl-[22px] !pr-[15px] md:!pr-[25px] lg:!pl-[45px]"
        }
      >
        <ContentWaper>
          <div className="text-aia-red text-center font-medium text-[18px] lg:text-[25px] tracking-[-0.96px] pb-[15px]">
            {T("Affiliate Program Terms and Conditions")}
          </div>
          <div className="modal-body content-agreement max-h-[calc(80vh-140px)]">
            {language != "ja" && (
              <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px] pt-[10px]">
                <div className="mb-[20px]">
                  <div className="font-bold text-[18px] text-left">
                    Article 1 (Purpose)
                  </div>
                  <p className="text-[16px] mb-[20px] text-left">
                    These Terms and Conditions establish the conditions related
                    to the affiliate program (hereinafter referred to as "the
                    Program") provided by [AI AVATAR Pte. Ltd.] (hereinafter
                    referred to as "the Company") and clarify the rights and
                    obligations between the Company and participants in the
                    affiliate program (hereinafter referred to as "Affiliates").
                  </p>
                </div>
                <div className="mb-[20px]">
                  <div className="font-bold text-[18px]">
                    Article 2 (Definitions)
                  </div>
                  <p className="text-[16px] mb-[20px]">
                    <ul className="list-decimal pl-10">
                      <li>
                        <div>"Affiliate"</div>
                        <div>
                          Refers to an individual or entity that agrees to these
                          Terms and Conditions and participates in the Program.
                        </div>
                      </li>
                      <li>
                        <div>"Affiliate Link"</div>
                        <div>
                          Refers to the link posted by the Affiliate on their
                          own website, blog, SNS, etc., that directs users to
                          the Company's or advertiser's website.
                        </div>
                      </li>
                      <li>
                        <div>"Commission"</div>
                        <div>
                          Refers to the reward paid by the Company to the
                          Affiliate based on the commission payment rules.
                        </div>
                      </li>
                    </ul>
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 3 (Eligibility for Participation)
                </div>
                <p className="text-[16px] mb-[20px]">
                  No qualifications or obligations are required to participate
                  in the Program.
                </p>
                <div className="font-bold text-[18px]">
                  Article 4 (Rewards and Payments)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[5px]">
                    The payment of rewards to this Program will be made
                    according to the methods and periods specified by the
                    Company.
                  </p>
                  <p>
                    Rewards generated through fraudulent means will not be paid.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 5 (Provision of Information on SNS Accounts)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="text-[16px] mb-[20px]">
                    All Affiliates must provide the Company with the account
                    names and other information of their social media accounts
                    used for promoting the Program upon request from the
                    Company.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 6 (Compliance with Regulations)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    All Affiliates pledge to comply with all laws, regulations,
                    and social norms and to conduct their activities with
                    integrity.
                  </p>
                </div>

                <div className="font-bold text-[18px]">
                  Article 7 (Prohibited Acts)
                </div>
                <div className="text-[16px]">
                  <p className="mb-[12px]">
                    All Affiliates must not engage in the following acts:
                  </p>
                  <ul className="list-decimal pl-10 mb-[12px]">
                    <li>
                      <div>
                        Unauthorized modification or alteration of data and
                        materials.
                      </div>
                    </li>
                    <li>
                      <div>
                        Conducting business activities in multiple positions
                        within AI AVATAR.
                      </div>
                    </li>
                    <li>
                      <div>
                        Using digital tools not approved by the Company (e.g.,
                        discussing business matters on personal LINE accounts).
                      </div>
                    </li>
                    <li>
                      <div >
                        Misrepresenting oneself as an employee of the Company to
                        a third party, despite not being affiliated with the
                        Company.
                      </div>
                    </li>
                  </ul>
                  <p className="mb-[20px]">
                    In the event of a violation of the above, the Company may
                    issue a strict warning.
                  </p>
                </div>

                <div className="font-bold text-[18px]">
                  Article 8 (Termination of Registration)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    The Company may terminate an Affiliate's registration
                    without prior notice if the Affiliate violates any of the
                    following:
                  </p>
                  <p className="mb-[12px]">
                    (1) Should the Affiliate receive a formal warning from the
                    Company concerning any matter specified in Article 7.{" "}
                    <span >
                      In instances where a violation of Article 7.4 is
                      identified, the Affiliate's registration may be terminated
                      immediately without the issuance of a formal warning.
                    </span>
                  </p>
                  <p className="mb-[12px]">
                    (2) In cases where it is determined that sales were
                    conducted through illegal means or inappropriate language.
                  </p>
                  <p className="mb-[12px]">
                    (3) If the Affiliate is found to be in violation of any
                    applicable laws.
                  </p>
                  <p className="">
                    After termination, the Official Affiliate cannot claim
                    unpaid rewards.
                  </p>
                </div>

                <div className="font-bold text-[18px]">
                  Article 9 (Disclaimer)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[10px]">
                    The Company assumes no responsibility for any damages
                    incurred by the all Affiliate in relation to the operation
                    of the Program.
                  </p>
                  <p className="mb-[20px]">
                    The Company is also not responsible for any damages caused
                    by system failures or fraudulent acts by third parties.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 10 (Handling of Personal Information)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    The Company will manage personal information appropriately
                    and handle it in accordance with the Company's privacy
                    policy.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 11 (Changes to the Terms)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    The Company may change these Terms and Conditions if deemed
                    necessary. The revised Terms will take effect once posted on
                    the Company's website.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 12 (Governing Law and Jurisdiction)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    The interpretation and application of these Terms and
                    Conditions will be governed by Japanese law.
                  </p>
                  <p className="mb-[20px]">
                    In the event of a dispute related to the Program, the courts
                    having jurisdiction over the Company's headquarters location
                    (Singapore) will have exclusive jurisdiction.
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  Article 13 (Confidentiality)
                </div>
                <div className="text-[16px] mb-[20px]">
                  <ul className="list-decimal pl-10 mb-[12px]">
                    <li>
                      <div>
                        Affiliate shall not disclose or disseminate to any third
                        party any technical, sales, business, customer, or other
                        confidential information pertaining to the Affiliate or
                        other Affiliates (“Confidential Information”) that is
                        obtained in connection with the Program without
                        obtaining prior written consent from the Affiliate.
                        Furthermore, the Affiliate shall not utilize such
                        Confidential Information for any purpose other than for
                        its own business objectives.
                      </div>
                    </li>
                    <li>
                      <div>
                        The following information shall not be deemed
                        Confidential Information:
                        <ul className="list-disc pl-10 mb-[12px]">
                          <li>
                            Information that is already in the public domain.
                          </li>
                          <li>
                            Information that enters the public domain prior to
                            its receipt by the Affiliate.
                          </li>
                          <li>
                            Information obtained by the Affiliate from a third
                            party with appropriate authorization.
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div>
                        Affiliates shall undertake all necessary measures to
                        ensure the proper management of Confidential
                        Information, safeguarding it from leakage, loss, or
                        misuse.
                      </div>
                    </li>
                    <li>
                      <div >
                        The provisions set forth in this Article shall remain in
                        effect even after the Affiliate's participation in the
                        Program has been terminated.
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}
            {language == "ja" && (
              <div className="text-[#000000] leading-[26px] md:pl-[5px] xs:pl-[5px] lg:pr-[20px] md:pr-[10px] xs:pr-[10px]">
                <div className="mb-[20px]">
                  <div className="font-bold text-[18px] text-left">
                    第1条（目的）
                  </div>
                  <p className="text-[16px] mb-[20px] text-left">
                    本規約は、[AI AVATAR Pte.
                    Ltd.]（以下、「当社」という）が提供するAffiliateプログラム（以下、「本プログラム」という）に関する条件を定め、当社とAffiliate参加者（以下、「Affiliate」という）との間の権利義務関係を明確にすることを目的とします。
                  </p>
                </div>
                <div className="mb-[20px]">
                  <div className="font-bold text-[18px]">第2条（定義）</div>
                  <ul className="list-decimal pl-10">
                    <li>
                      <div>「Affiliate」</div>
                      <div>
                        本規約に同意し、本プログラムに参加する個人または法人を指します。
                      </div>
                    </li>
                    <li>
                      <div>「Affiliateリンク」</div>
                      <div>
                        Affiliateが自身のウェブサイト、ブログ、SNS等に掲載する、当社または広告主のウェブサイトへ誘導するリンクを指します。
                      </div>
                    </li>
                    <li>
                      <div>コミッション</div>
                      <div>
                        コミッション支払ルールに基づき、当社からAffiliateに支払われる報酬を指します。
                      </div>
                    </li>
                  </ul>
                </div>
                <div className="font-bold text-[18px]">第3条（参加資格）</div>
                <p className="text-[16px] mb-[20px]">
                  本プログラムに参加するには、何らの資格及び負担も必要ありません。
                </p>
                <div className="font-bold text-[18px]">
                  第4条（報酬および支払い）
                </div>
                <div className="text-[16px]">
                  <p className="mb-[20px]">
                    本プログラムの報酬の支払いは、当社が指定する方法および期間に従って行われます。
                    不正な手段により発生した報酬は支払われません。
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  第5条（SNSアカウントの情報提供）
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="text-[16px] mb-[20px]">
                    全Affiliateは、当社に対して本プログラムの宣伝に使用するSNSアカウントのアカウント名等の情報を、当社の求めに応じて提供します。
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  第6条（コンプライアンス遵守）
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    全Affiliateは、法令や社会規範を遵守し、誠実に活動を行うことを誓います。
                  </p>
                </div>

                <div className="font-bold text-[18px]">第7条（禁止事項）</div>
                <div className="text-[16px] mb-[20px]">
                  <p className=" mb-[8px]">
                    Affiliateは以下の行為を行ってはなりません。
                  </p>
                  <ul className="list-decimal pl-10">
                    <li>
                      <div>データおよび資料の無断修正及び改ざん</div>
                    </li>
                    <li>
                      <div>AI-AVATARでの複数ポジションのビジネス活動</div>
                    </li>
                    <li>
                      <div>不適切な手段・文言を用いて宣伝を行うこと</div>
                    </li>
                    <li>
                      <div>
                        <span >
                          当社の社員でないにもかかわらず、第三者に対し当社の社員であると名乗ること
                        </span>
                        上記に違反した場合、当社から厳重注意を行う場合があります。
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="font-bold text-[18px]">第8条（登録の解除）</div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[8px]">
                    当社は、Affiliateが以下の事項のいずれかに違反した場合、事前の通知なくAffiliate登録を解除することができます。
                  </p>
                  <p className="mb-[12px]">
                    （1）第7条各号に掲げる事項に関し、当社から厳重注意を受けたとき。
                    <span >
                      ただし、第7条4号に違反したことが発覚した場合は、厳重注意を行うことなく解除することがあります
                    </span>
                  </p>
                  <p className="mb-[12px]">
                    （2）違法な手段・文言を用いて販売を行ったことが判明したとき
                  </p>
                  <p className="mb-[12px]">
                    （3）Affiliateが法令違反をしたことが判明したとき
                  </p>
                  <p className="mb-[20px]">
                    登録解除後、Affiliateは未払いの報酬を請求することはできません。
                  </p>
                </div>

                <div className="font-bold text-[18px]">第9条（免責事項）</div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[4px]">
                    当社は、本プログラムの運営に関し、Affiliateに生じた損害について一切の責任を負いません。
                  </p>
                  <p className="mb-[4px]">
                    当社は、システム障害や第三者による不正行為等により発生した損害についても、一切の責任を負いません。
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  第10条（個人情報の取扱い）
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    当社は、個人情報を適切に管理し、当社のプライバシーポリシーに基づき取り扱います。
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  第11条（約款の変更）
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[20px]">
                    当社は、必要と判断した場合、本規約を変更することができます。変更後の約款は、当社のウェブサイトに掲載した時点で効力を生じるものとします。
                  </p>
                </div>
                <div className="font-bold text-[18px]">
                  第12条（準拠法および裁判管轄）
                </div>
                <div className="text-[16px] mb-[20px]">
                  <p className="mb-[4px]">
                    本規約の解釈および適用は、日本法に準拠するものとします。
                  </p>
                  <p className="mb-[4px]">
                    本プログラムに関する紛争が生じた場合、本社所在地（シンガポール）を管轄する裁判所を専属的合意管轄とします。
                  </p>
                </div>
                <div className="font-bold text-[18px]">第13条（機密保持）</div>
                <div className="text-[16px] mb-[20px]">
                  <ul className="list-decimal pl-10 mb-[12px]">
                    <li>
                      <div>
                        Affiliateは、本プログラムに関連して知り得た当社または他のAffiliateの技術情報、営業情報、業務情報、顧客情報その他の機密情報（以下、「機密情報」という）を、当社の事前の書面による承諾を得ずに第三者に開示、漏洩してはならず、また自己の業務目的以外に使用してはなりません。
                      </div>
                    </li>
                    <li>
                      <div>
                        以下に該当する情報は、機密情報には該当しないものとします。
                        <ul className="list-disc pl-10 mb-[12px]">
                          <li>既に公知であった情報</li>
                          <li>Affiliateが受領する前に公知であった情報</li>
                          <li>
                            Affiliateが正当な権限に基づき第三者から取得した情報
                          </li>
                        </ul>
                      </div>
                    </li>
                    <li>
                      <div>
                        Affiliateは、機密情報を適切に管理し、当該情報の漏洩、紛失、不正使用がないよう必要な措置を講じるものとします。
                      </div>
                    </li>
                    <li>
                      <div >
                        本条の規定は、Affiliateが本プログラムを終了した後も有効に存続します。
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}
          </div>
          <div className="flex flex-row justify-center items-center pt-6 gap-[15px] border-0  ">
            <button
              className="sm:w-[192px] w-[100%] h-[52px] px-5 py-4 bg-[#ffffff] text-[#000000] text-center rounded-[15px]"
              style={{ border: "1px solid #000000" }}
              type="button"
              onClick={onClose}
            >
              {T("Decline")}
            </button>
            <button
              className="sm:w-[192px] w-[100%] h-[52px] px-5 py-4 bg-black text-white text-center rounded-[15px]"
              type="button"
              onClick={() => handleSubmit()}
            >
              {T("Accept")}
            </button>
          </div>
        </ContentWaper>
      </Modal.Container2>
    </Modal>
  );
};
